<template>
    <div class="row no-padding" v-if="isFetchingData===false">
        <div class="col-xs-12">
            <h4 class="text-center">{{'My Badge'|trans}}</h4>
            <badge_current  v-bind:badgeData="badgesData['badge']"></badge_current>
            <br>
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link" v-bind:class="{'active':currentOpenTab==='badges-list'}"
                       @click="currentOpenTab='badges-list'"
                    >
                        {{'Badges'|trans}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-bind:class="{'active':currentOpenTab==='badges-history'}"
                       @click="currentOpenTab='badges-history'"
                    >
                        {{'History'|trans}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-bind:class="{'active':currentOpenTab==='badges-info'}"
                       @click="currentOpenTab='badges-info'"
                    >
                        {{'info'|trans}}
                    </a>
                </li>
            </ul>
        </div>
        <div class="col-xs-12">
            <badges_list v-if="currentOpenTab==='badges-list'"  v-bind:user="user" v-bind:badgeData="badgesData['badge']"></badges_list>
            <badges_history v-if="currentOpenTab==='badges-history'"  v-bind:user="user" v-bind:historyPoints="badgesData['history']"></badges_history>
            <badges_info v-if="currentOpenTab==='badges-info'" v-bind:user="user"></badges_info>
        </div>
    </div>
</template>

<script>

    import Badges_list from "./badges_list";
	import Badges_info from "./badges_info";
	import Badges_history from "./badges_history";
	import Badge_current from "./badge_current";
	export default {
		components: {Badge_current, Badges_history, Badges_info, Badges_list},
		props: {
			user:Object
        },
        data() {
            return {
                currentOpenTab : 'badges-list',
                badgesData : null,
				isFetchingData:false
            }
        },
        async created(){
            await this.getBadgesData();
        },
        methods: {
			async getBadgesData(){
				this.isFetchingData=true;
				this.badgesData = await this.$api.worker.getBadges();
                this.isFetchingData=false;
			},
        },
        computed: {

        },
    }

</script>

<style scoped>
    .active{
        background:#363d47;
        color:white;
    }
    .active:hover{
        background:#363d47 !important;
        color:white;
    }


</style>
